module.exports = __webpack_public_path__ + "static/media/Alien Trooper.09139e5e.jpg";